module.exports = (__webpack_public_path__ || '') + "static/images/photo-10-97cf5ffd3d7fe871697b6c8b9fb8572b.jpg";